import request from '@/utils/request'

//======旧的统计=====旧的统计======旧的统计=======旧的统计======云平台
//统计同一课程 课程总时长、平均观看时长、最快观看时长
export function courseWatchTimeInfo(data) {
	return request({
		url: '/api/statistical/courseWatchTimeInfo',
		method: 'get',
		params: data
	})
}
//统计同一课程 章的学习人次
export function chapterStudycount(data) {
	return request({
		url: '/api/statistical/chapterStudycount',
		method: 'get',
		params: data
	})
}
//统计同一课程 小节的学习人次、笔记数、评论数
export function sectionStudyInfo(data) {
	return request({
		url: '/api/statistical/sectionStudyInfo',
		method: 'get',
		params: data
	})
}
//课程总时长，总学习人数，课程学习最长学生姓名、时长，今天学习课程的人数
export function courseStatistical(data) {
	return request({
		url: '/api/statistical/courseStatistical',
		method: 'get',
		params: data
	})
}
//统计本校的学生总数，学习本课程的本校人数，学习本课程的总人数
export function statisticalStudentInfo(data) {
	return request({
		url: '/api/statistical/statisticalStudentInfo',
		method: 'get',
		params: data
	})
}

//======课程统计=====课程统计======课程统计=======课程统计======
//统计当前登录教师人员创建的课程总数、总课件数、总视频数、总试题数、总学习人数、作业总数、考试总数、直播总数
export function teacherCourseStatistical(data) {
	return request({
		url: '/api/statistical/teacherCourseStatistical',
		method: 'get',
		params: data
	})
}

//统计当前登录教师的具体课程信息
export function teacherCourseInfoStatistical(data) {
	return request({
		url: '/api/statistical/teacherCourseInfoStatistical',
		method: 'get',
		params: data
	})
}
//统计所有教师人员创建的课程总数、总课件数、总视频数、总试题数、总学习人数、作业总数、考试总数、直播总数
export function allTeacherCourseStatistical(data) {
	return request({
		url: '/api/statistical/allTeacherCourseStatistical',
		method: 'get',
		params: data
	})
}

//根据用户ID统计教师的具体课程信息
export function teacherCourseInfoStatisticalById(data) {
	return request({
		url: '/api/statistical/teacherCourseInfoStatisticalById',
		method: 'get',
		params: data
	})
}
//======作业统计=====作业统计======作业统计=======作业统计======
//统计当前登录教师课程中的作业数
export function teacherCourseTask(data) {
	return request({
		url: '/api/statistical/teacherCourseTask',
		method: 'get',
		params: data
	})
}
//根据用户id统计课程中的作业数
export function courseTaskByUserId(data) {
	return request({
		url: '/api/statistical/courseTaskByUserId',
		method: 'get',
		params: data
	})
}
//根据课程id统计作业信息与答题人数、平均分
export function taskInfoByCourseId(data) {
	return request({
		url: '/api/statistical/taskInfoByCourseId',
		method: 'get',
		params: data
	})
}

//根据作业Id查询做作业的人员信息
export function taskUserInfoByTaskId(data) {
	return request({
		url: '/api/statistical/taskUserInfoByTaskId',
		method: 'get',
		params: data
	})
}

//根据作业ID查询作业中出错最多的试题
export function errorTopicByTaskId(data) {
	return request({
		url: '/api/statistical/errorTopicByTaskId',
		method: 'get',
		params: data
	})
}
//======考试统计=====考试统计======考试统计=======考试统计======
//根据用户id查询所创建的考核信息、考试人数、平均分
export function examInfoByUserId(data) {
	return request({
		url: '/api/statistical/examInfoByUserId',
		method: 'get',
		params: data
	})
}
//根据考核Id查询做作业的人员信息
export function examUserInfoByExamId(data) {
	return request({
		url: '/api/statistical/examUserInfoByExamId',
		method: 'get',
		params: data
	})
}

//根据考核ID查询作业中出错最多的试题
export function errorTopicByExamId(data) {
	return request({
		url: '/api/statistical/errorTopicByExamId',
		method: 'get',
		params: data
	})
}
//======学生端统计=====学生端统计======学生端统计=======学生端统计======
//根据用户Id统计学生用户的、学习课程数、学习总时长、课程笔记总数、作业总数、考试总次数、发起评论的次数、回复的次数******
export function studentStatistical(data) {
	return request({
		url: '/api/statistical/studentStatistical',
		method: 'get',
		params: data
	})
}

//统计当前登录学生用户的、学习课程数、学习总时长、课程笔记总数、作业总数、考试总次数、发起评论的次数、回复的次数
export function loginStudentStatistical(data) {
	return request({
		url: '/api/statistical/loginStudentStatistical',
		method: 'get',
		params: data
	})
}
//======学生端课程统计=====学生端课程统计======学生端课程统计=======学生端课程统计======
//根据用户Id查询课程信息、课程的完成度、笔记数******
export function studentCourseStatisticalById(data) {
	return request({
		url: '/api/statistical/studentCourseStatisticalById',
		method: 'get',
		params: data
	})
}
//查询当前登录学生课程信息、课程的完成度、笔记数
export function myCourseStatistical(data) {
	return request({
		url: '/api/statistical/myCourseStatistical',
		method: 'get',
		params: data
	})
}
//根据用户id查询作业信息、得分情况******
export function taskInfoStatistical(data) {
	return request({
		url: '/api/statistical/taskInfoStatistical',
		method: 'get',
		params: data
	})
}
//统计当前登录学生作业信息、得分情况
export function myTaskInfoStatistical(data) {
	return request({
		url: '/api/statistical/myTaskInfoStatistical',
		method: 'get',
		params: data
	})
}
//根据用户id查询考核信息、等分情况******
export function examInfoStatistical(data) {
	return request({
		url: '/api/statistical/examInfoStatistical',
		method: 'get',
		params: data
	})
}
//统计当前登录学生考核信息、等分情况
export function myExamInfoStatistical(data) {
	return request({
		url: '/api/statistical/myExamInfoStatistical',
		method: 'get',
		params: data
	})
}
//统计用户数/访问人次
export function systemCountStatistical(data) {
	return request({
		url: '/api/statistical/admin/systemCountStatistical',
		method: 'get',
		params: data
	})
}
